import {Injectable} from "@angular/core";
import {Subject} from "rxjs/Subject";
import {AppMessage, IListConfig} from "../definitions";
import {APP_MESSAGES} from "../enums/enums";
import {Observable} from "rxjs/Observable";
import {CollectionParams} from "../helpers/params/collection-params";
import {ILocaleItem} from "../components/nv-locale/nv-locale.component";
import {IDocument} from "../interfaces/document.definition";
import {E_ENDPOINTS} from "../helpers/params/loader-params";

@Injectable()
export class ModalService {
  private subject:Subject<AppMessage> = new Subject();


  constructor() { }


  public get onModalRequest():Observable<AppMessage> {
    return this.subject.asObservable();
  }


  showUnsavedWarning() {
    this.showWarning("Есть несохраненные изменения!");
  }


  showJson(json:any):void {
    this.subject.next(new AppMessage(APP_MESSAGES.JSON, json));
  }

  showError(error:Error) {
    this.subject.next(new AppMessage(APP_MESSAGES.ERROR, error));
  }


  showWarning(message:string) {
    this.subject.next(new AppMessage(APP_MESSAGES.WARNING, message));
  }

  showHistoryJournal(){
    this.send(APP_MESSAGES.POPUP_HISTORY_JOURNAL,{});
  }

  showMetaImportPopup(metaInName:string){
    this.send(APP_MESSAGES.POPUP_META_IMPORT, metaInName);
  }

  showLocaleEditor(item: ILocaleItem) {
    this.send(APP_MESSAGES.POPUP_LOCALE_EDITOR, item)
  }


  showSpineUpload(document: IDocument) {
    this.send(APP_MESSAGES.POPUP_SPINE_EDITOR_MODAL, document);
  }

  showFmanager(document:IDocument, pointer:String) {
    this.send(APP_MESSAGES.POPUP_FMANAGER_MODAL, {document, pointer});
  }

  showImageUpload(document: IDocument, pointer:String) {
    this.send(APP_MESSAGES.POPUP_IMAGE_EDITOR_MODAL, {document, pointer});
  }


  showConfirm(message:string, onConfirm:() => void):void {
    this.send(APP_MESSAGES.POPUP_CONFIRM, {message:message, action:onConfirm});
  }

  showMessage(msg:string):void {
    this.send(APP_MESSAGES.POPUP_MESSAGE, msg);
  }


  private send(type: APP_MESSAGES, content: any) {
    this.subject.next(new AppMessage(type, content));
  }


  /**
   * @todo rename -> showSelector
   * @param listConfig
   * @param container
   * @returns {Observable<T>}
   */
  showSelector(listConfig:IListConfig, container:any[]):Observable<IDocument> {
    let subject = new Subject<IDocument>();

    let data = {
      listConfig: listConfig,
      container: container,
      subject: subject
    };

    this.subject.next(new AppMessage(APP_MESSAGES.POPUP_QUERY__SELECT, data));

    return subject.asObservable().first();
  }


  showSelector22(collectionParams: CollectionParams) {
    const subject = new Subject<IDocument>();
    const data = { collectionParams, subject };

    this.subject.next(new AppMessage(APP_MESSAGES.POPUP_QUERY__SELECT, data));

    return subject.asObservable().first();
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/services/modal.service.ts